(function() {
  var DialogController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DialogController = App.loadClass('core::Angular/DialogController');

  exports.BinInspectionsController = (function(superClass) {
    extend(BinInspectionsController, superClass);

    function BinInspectionsController(scope, transitions, modalInstance, service, loading, bin, year) {
      var i, ref, results;
      this.scope = scope;
      this.transitions = transitions;
      this.modalInstance = modalInstance;
      this.service = service;
      this.loading = loading;
      this.unsetCleanliness = bind(this.unsetCleanliness, this);
      BinInspectionsController.__super__.constructor.apply(this, arguments);
      this.scope.title = 'Bin Inspection';
      this.scope.save = (function(_this) {
        return function() {
          var promise;
          promise = _this.inspection.id != null ? _this.inspection.$update() : _this.inspection.$save();
          return promise.then(function() {
            return _this.modalInstance.close();
          })["catch"](function(msg) {
            var errorMessages, errors, i, len, property, ref, validationError;
            errorMessages = [];
            ref = msg.data;
            for (property in ref) {
              errors = ref[property];
              for (i = 0, len = errors.length; i < len; i++) {
                validationError = errors[i];
                errorMessages.push(validationError);
              }
            }
            if (errorMessages.length) {
              return _this.setAlert({
                msg: 'Validation Errors',
                type: 'error'
              }, errorMessages);
            }
          });
        };
      })(this);
      if (bin.inspection != null) {
        this.inspection = bin.inspection;
        if (this.inspection.other_debris) {
          this.inspection.has_other_debris = true;
        }
      } else {
        this.inspection = new this.service.BinInspection({
          storage_locations_id: bin.id,
          year: year
        });
        bin.inspection = this.inspection;
      }
      this.concreteBaseConditions = ['Good', 'Fair', 'Poor'];
      this.generalConstructionOptions = ['Good', 'Fair', 'Poor'];
      this.lastPulledYears = (function() {
        results = [];
        for (var i = ref = moment().year(); ref <= 1955 ? i <= 1955 : i >= 1955; ref <= 1955 ? i++ : i--){ results.push(i); }
        return results;
      }).apply(this);
    }

    BinInspectionsController.prototype.unsetCleanliness = function() {
      if (this.inspection.is_clean) {
        this.inspection.has_animal_waste = false;
        this.inspection.has_insect_activity = false;
        this.inspection.has_foreign_crops = false;
        this.inspection.has_other_debris = false;
        return this.inspection.other_debris = null;
      }
    };

    return BinInspectionsController;

  })(DialogController);

}).call(this);
